import { device } from '@/utils/devices-screens';
import styled from 'styled-components';

export const BannerWrapper =  styled.div`
`;
export const BannerImg = styled.img`
    width: 100%;
    border-radius: 8px;

    @media ${device.tablet}{
        border-radius: 0;
    }
`;

export const ProductsContainer = styled.div`
`;

export const ProductsList = styled.div<{ quantity: number }>`
    justify-items: center;
    max-width: ${props => {
        if (props.quantity === 2) {
            return "768px";
        }
        
        if (props.quantity === 3) {
            return "1200px";
        }
        return "1600px"
    }};
    margin: 0 auto;
    display: grid;
    gap: 40px;
    padding-bottom: 10px;
    place-items: center center;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));

    @media ${device.tablet} {
        justify-content: center;
        padding: 20px;
        /* grid-template-columns: repeat(1, minmax(100px, 1fr)); */
    }
`;

export const RegulationContainer = styled.div`
    border-top: 1px solid #ccc;
    margin-top: 80px;
    height: 300px;
    overflow-y: auto;
    padding: 25px 10px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;

    h3 {
        font-size: 14px;
    }

    p {
        margin-bottom: 5px;
        font-size: 14px;
    }

    strong {
        font-size: 12px;
    }
`;